// @flow

const breakpointNameToAttribute = (breakpointName: string): string =>
    breakpointName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

export { breakpointNameToAttribute };



// WEBPACK FOOTER //
// ./static/src/javascripts/projects/commercial/modules/dfp/breakpoint-name-to-attribute.js